import {
  FaPhoneAlt,
  FaFacebookMessenger,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { SiZalo } from "react-icons/si";

const contacts = [
  {
    name: "Gọi điện",
    link: "tel:0786529313",
    icon: <FaPhoneAlt size={20} color="#ffffff" />,
    bgColor: "bg-green-500",
  },
  {
    name: "Messenger",
    link: "https://www.facebook.com/daylaixe.quoc",
    icon: <FaFacebookMessenger size={40} color="#0084FF" />,
    bgColor: "bg-white",
  },
  {
    name: "Zalo",
    link: "https://zalo.me/0786529313",
    icon: <SiZalo size={40} color="#0068FF" />,
    bgColor: "bg-white",
  },
  {
    name: "Maps",
    link: "https://www.google.com/maps/place/10%C2%B053'51.8%22N+106%C2%B047'48.5%22E/@10.897708,106.7942384,17z/data=!3m1!4b1!4m7!1m2!10m1!1e2!3m3!8m2!3d10.897708!4d106.7968133?entry=ttu&g_ep=EgoyMDI1MDgxOS4wIKXMDSoASAFQAw%3D%3D",
    icon: <FaMapMarkerAlt size={30} color="#EA4335" />,
    bgColor: "bg-white",
  },
];

const FloatingContact = () => {
  return (
    <div className="fixed right-5 top-[320px] flex flex-col gap-6 z-50">
      {contacts.map((contact, idx) => (
        <a
          key={idx}
          href={contact.link}
          target="_blank"
          rel="noopener noreferrer"
          className={`relative w-14 h-14 flex items-center justify-center rounded-full shadow-xl hover:scale-110 transition-transform duration-300 ${contact.bgColor}`}
          title={contact.name}
        >
          {/* Nhấp nháy mạnh */}
          <span className="absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-40 animate-customPulse"></span>

          {/* Icon chính */}
          <span className="relative z-10">
            {contact.icon}
          </span>
        </a>
      ))}
    </div>
  );
};

export default FloatingContact;
